import styled from "styled-components";
import { Link } from 'react-router-dom';
import { Color} from 'styles';


export const StyledWrapper = styled(Link)`
  background: ${Color.Black};
  display: inline-block;
  height: 142px;
  width: 238px;
`;

export const StyledTitle = styled.span`
  color: ${Color.White};
  display: block;
  font-size: 29.5px;
  margin-top: 42px;
  position: relative;
  text-align: center;
  
  span {
    color: ${Color.Orange};
  }
  
  &:after {
    color: ${Color.White};
    content: 'ZADBAJ O SWOJE AUTO';
    display: inline-block;
    font-size: 8px;
    position: absolute;
    right: 25px;
    top: 35px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/logo/logo.style.js